import { ComponentThemeType } from './theme.types';

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutral: true;
    tertiary: true;
  }
}

declare module '@mui/material/ButtonGroup' {
  interface IconButtonPropsColorOverrides {
    neutral: true;
    tertiary: true;
  }
}

declare module '@mui/material/IconButton' {
  interface IconButtonPropsColorOverrides {
    neutral: true;
    tertiary: true;
  }
}

export const buttonsTheme: ComponentThemeType = {
  MuiButtonGroup: {},
  MuiButton: {
    styleOverrides: {
      root: ({ theme: { palette } }) => ({
        boxSizing: 'border-box',
        textTransform: 'none',
        borderRadius: 10,
        fontWeight: 500,
        '.MuiChip-root': {
          height: '17px',
        },
        boxShadow: 'none',
        '.MuiButton-startIcon': {
          color: 'inherit',
        },
        '& > span': {
          color: palette.tertiary.light,
        },
      }),
    },
    variants: [
      {
        props: { variant: 'contained' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: palette.primary.light,
          '&:hover': {
            color: palette.primary.light,
            backgroundColor: palette.primary.main,
          },
        }),
      },
      {
        props: { variant: 'contained', color: 'success' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: palette.primary.light,
          '&:hover': {
            backgroundColor: palette.primary.main,
          },
        }),
      },
      {
        props: { variant: 'contained', color: 'error' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: palette.error.main,
          '&:hover': {
            backgroundColor: palette.error.light,
          },
        }),
      },
      {
        props: { variant: 'text', color: 'secondary' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: palette.grey[200],
          color: 'black',
        }),
      },
      {
        props: { variant: 'outlined', color: 'primary' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: 'transparent',
          borderRadius: 10,
          borderColor: palette.primary.main,
        }),
      },
      {
        props: { variant: 'outlined', color: 'error' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: 'transparent',
          borderRadius: 10,
          borderColor: palette.error.main,
        }),
      },
      {
        props: { variant: 'outlined', color: 'info' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: 'transparent',
          borderRadius: 10,
          borderColor: palette.info.main,
        }),
      },
      {
        props: { variant: 'outlined', color: 'secondary' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: 'transparent',
          borderRadius: 10,
          borderColor: palette.secondary.main,
        }),
      },
      {
        props: { variant: 'outlined', color: 'success' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: 'transparent',
          borderRadius: 10,
          borderColor: palette.success.main,
        }),
      },
      {
        props: { variant: 'outlined', color: 'warning' },
        style: ({ theme: { palette } }) => ({
          backgroundColor: 'transparent',
          borderRadius: 10,
          borderColor: palette.warning.main,
        }),
      },
    ],
  },
  MuiIconButton: {
    variants: [
      {
        props: { size: 'large', color: 'primary' },
        style: ({ theme: { palette } }) => ({
          border: `1px solid ${palette.grey[200]}`,
        }),
      },
    ],
  },
};
